import { type EnvironmentInjector, computed, inject } from '@angular/core';

import { type LazyComponentDetails } from '@core/shared/util';
import { JobServerPermissions } from '@mp/shared/feature';
import { type ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import {
  type SystemInfoTabPlugin,
  type SystemInfoTabPluginInput,
} from '@mp/system/info/system-info-tab-plugin/util';
import { LoginContextService } from '@mpk/shared/data-access';

/**
 * Plugin-Factory für den Tab "Wiederkehrende Jobs" auf der `/system/info`-Seite.
 * Sichtbarkeit ist an `JobServerPermissions.ViewJobs` gekoppelt — dieselbe Berechtigung,
 * die auch den Hangfire-Dashboard-Link freischaltet.
 */
export function createContentManagerRecurringJobsTabPlugin(): SystemInfoTabPlugin {
  const loginContextService = inject(LoginContextService);
  const hasPermission = loginContextService.permission(JobServerPermissions.ViewJobs);

  return {
    label: 'Wiederkehrende Jobs',
    route: 'recurring-jobs',
    isEnabled: computed(() => hasPermission()),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<SystemInfoTabPluginInput>>> {
      const { RecurringJobsTabComponent } = await import('../components');

      return {
        component: RecurringJobsTabComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
